// TermsPage.jsx
import React, { useState, useEffect } from "react";
// import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import { fetchTermsOfService } from "../../services/LegalService"; // import serwisu
import "./TermsPage.css";

const TermsPage = () => {
  const [termsData, setTermsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadTerms = async () => {
      try {
        const data = await fetchTermsOfService("en");
        setTermsData(data);
      } catch (err) {
        setError("Failed to load terms");
      } finally {
        setLoading(false);
      }
    };

    loadTerms();
  }, []);

  if (loading) {
    return (
      <main className="terms-page">
        {/* <PageHeader title="Terms and Conditions" description="" /> */}
        <div className="terms-container">Loading...</div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="terms-page">
        {/* <PageHeader title="Terms and Conditions" description="" /> */}
        <div className="terms-container">{error}</div>
      </main>
    );
  }

  return (
    <main className="terms-page">
      <header className="features__hero">
        <h1>Terms and Conditions</h1>
      </header>

      {/* <PageHeader title="Terms and Conditions" description="Service usage rules and conditions" /> */}

      <div className="terms-container">
        {/* INTRO */}
        {/* {termsData[0]?.header && (
          <div className="terms-intro">
            <h1>{termsData[0].header}</h1>
            {termsData[0].steps.map((step, idx) => (
              <h3 key={idx}>{step}</h3>
            ))}
          </div>
        )} */}

        {/* SEKCJE */}
        {termsData.slice(1).map((section, idx) => (
          <section key={idx} className="terms-section">
            <h2>{section.header}</h2>
            {section.steps.map((step, stepIdx) => (
              <p key={stepIdx} className="terms-paragraph">
                {step}
              </p>
            ))}
          </section>
        ))}
      </div>
    </main>
  );
};

export default TermsPage;
